// extracted by mini-css-extract-plugin
export default {"wrap":"SectionLabel_wrap__v9Blx","serial":"SectionLabel_serial__4fHf9","dash":"SectionLabel_dash__J9sww","label":"SectionLabel_label__4LG1L"};